import { useState } from 'react';
import withdrawService from '../services/withdrawService';

export const useWithdraw = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [successDetails, setSuccessDetails] = useState(null);

  const createBankWithdrawal = async (amount, bankDetails = {}) => {
    setLoading(true);
    setError(null);
    setIsSuccess(false);
    setSuccessDetails(null);

    try {
      const response = await withdrawService.createBankWithdrawal(amount);
      
      // Add bank details to success info
      const details = {
        'Amount': `₦${parseFloat(amount).toLocaleString()}`,
        'Type': 'Bank Transfer',
        'Account Name': bankDetails.accountName || '',
        'Account Number': bankDetails.accountNumber || '',
        'Bank Name': bankDetails.bankName || '',
        'Reference ID': response.reference_id || response.id || 'N/A',
        'Status': 'Pending Review'
      };
      
      setSuccessDetails(details);
      setIsSuccess(true);
      
      return response;
    } catch (err) {
      setError(err.error || 'Bank withdrawal failed');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const createCryptoWithdrawal = async (withdrawalData) => {
    setLoading(true);
    setError(null);
    setIsSuccess(false);
    setSuccessDetails(null);

    try {
      const response = await withdrawService.createCryptoWithdrawal(withdrawalData);
      
      const details = {
        'Amount': `${parseFloat(withdrawalData.amount)} ${withdrawalData.cryptocurrency || 'USDT'}`,
        'Type': 'Crypto Withdrawal',
        'Wallet Address': `${withdrawalData.wallet_address.substring(0, 8)}...${withdrawalData.wallet_address.substring(withdrawalData.wallet_address.length - 8)}`,
        'Network': withdrawalData.network || '',
        'Reference ID': response.reference_id || response.id || 'N/A',
        'Status': 'Pending Review'
      };
      
      setSuccessDetails(details);
      setIsSuccess(true);
      
      return response;
    } catch (err) {
      setError(err.error || 'Crypto withdrawal failed');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const getWithdrawalHistory = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await withdrawService.getWithdrawalHistory();
      setLoading(false);
      return response;
    } catch (err) {
      setError(err.error || 'Failed to fetch withdrawal history');
      setLoading(false);
      throw err;
    }
  };

  const showSuccess = (details = {}) => {
    setSuccessDetails(details);
    setIsSuccess(true);
  };

  const hideSuccess = () => {
    setIsSuccess(false);
    setSuccessDetails(null);
  };

  const resetState = () => {
    setError(null);
    setIsSuccess(false);
    setSuccessDetails(null);
    setLoading(false);
  };

  return {
    loading,
    error,
    isSuccess,
    successDetails,
    createBankWithdrawal,
    createCryptoWithdrawal,
    getWithdrawalHistory,
    showSuccess,
    hideSuccess,
    resetState
  };
};